import { h, Component } from 'preact';
import React from 'preact';
import MenuObject from '../canvas/menu-object';
import MenuObjectStyles from './MenuObjectStyles';
import MenuObjectNameNoteStyles from './MenuObjectNameNoteStyles';
import MenuObjectPriceDividers from './MenuObjectPriceDividers';
import IconStyles from './IconStyles';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import util from "../util";
import store from "../store";
import constants from "../constants";
import { Switch } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import menuObject from '../canvas/menu-object';
import MenuObjectModifierDividers from './MenuObjectModifierDividers';

export default @connect(reduce, actions)
class AsideMenuObjectStyles extends Component {
  constructor() {
    super()
    this.state = {
      objects: []
    };

    this.applyToAll = this.applyToAll.bind(this);

    this.openColorPicker = (type) => {
      util.openColorPicker(type, false);
    }

    this.openColorPickerName = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'name']);
    }

    this.openColorPickerDescription = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'description']);
    }

    this.openColorPickerPrice = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'price']);
    }

    this.openColorPickerSinglePrice = (num) => {
      this.openColorPicker([constants.pickerTypes.moFont, `price-entry:nth-child(${num})`]);
    }

    this.openColorPickerExtras = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'extras']);
    }

    this.openColorPickerModifierName = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'modifier-name']);
    }

    this.openColorPickerModifierEntryName = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'modifier-entry-name']);
    }

    this.openColorPickerModifierEntryPrice = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'modifier-entry-price']);
    }

    this.openColorPickerBin = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'bin']);
    }

    this.openColorPickerTag = () => {
      this.openColorPicker([constants.pickerTypes.moFont, 'tag']);
    }

    this.openColorPickerIcon = () => {
      this.openColorPicker(constants.pickerTypes.moIconFill);
    }

    this.openColorPickerMOName = () => {
      this.openColorPicker(constants.pickerTypes.moNameFont);
    }

    this.openColorPickerMONotes = () => {
      this.openColorPicker(constants.pickerTypes.moNotesFont);
    }

    this.startApplyToMoMode = (ev, applyMode) => {
      ev.stopPropagation();
      menuObject.startApplyToMoMode(this.props.$element, applyMode)
    }
  }

  applyToAll(label, applyMode) {
    window.ConfirmationModal.show({
      title: 'Are you sure?',
      body: `This will apply the current ${label} to the entire menu.`,
      acceptLabel: '<span id="applyToAllConfirmBtn">Yes, apply to all</span>',
      declineLabel: 'Cancel',
      hideOnAccept: false,
      onAccept: () => {
        util.onApplyToAllConfirm();
        util.nextTick(() => {
          MenuObject.applyToAll(this.props.$element, applyMode);
          window.ConfirmationModal.hide();
        })
      },
      onDecline: () => {
        window.ConfirmationModal.hide();
      }
    });
  };

  onMONameStyleChange(key, value) {
    this.update('mo-name', key, value);
  }

  onMONoteStyleChange(key, value) {
    this.update('mo-notes', key, value);
  }

  onItemNameStyleChange(key, value) {
    this.update('name', key, value);
  }

  onIconStyleChange(key, value) {
    this.update('icon-entry', key, value);
  }

  onAllIconStyleChange(key, value) {
    this.update('icon', key, value);
  }

  onDescriptionStyleChange(key, value) {
    this.update('description', key, value);
  }

  onPriceStyleChange(key, value) {
    this.update('price', key, value);
  }

  onSinglePriceStyleChange(key, value, num) {
    this.update(`price-entry:nth-child(${num})`, key, value);
  }

  onExtrasStyleChange(key, value) {
    this.update('extras', key, value);
  }

  onBinStyleChange(key, value) {
    this.update('bin', key, value);
    this.update('bin-header', key, value);
  }

  onTagStyleChange(key, value) {
    this.update('tag', key, value);
  }

  onModifierNameStyleChange(key, value) {
    this.update('modifier-name', key, value);
  }

  onModifierEntryNameStyleChange(key, value) {
    this.update('modifier-entry-name', key, value);
  }

  onModifierEntryPriceStyleChange(key, value) {
    this.update('modifier-entry-price', key, value);
  }

  updateShowMenuTag(key) {
    MenuObject.updateShowMenuTag(this.props.$element, key);
    this.props.setShowMenuTag(key);
  }

  updateShowModifiers(key) {
    MenuObject.updateShowModifiers(this.props.$element, key);
    this.props.setShowModifiers(key);
  }

  updateModifierLayout(switchOn) {
    let key = switchOn ? 'stacked' : 'in-line';
    MenuObject.updateModifierLayout(this.props.$element, key);
    this.props.setModifierLayout(key);
  }

  updateHidePrices(key) {
    MenuObject.updateHidePrices(this.props.$element, !key);
    this.props.setHidePrices(!key);
  }

  updateHideTrailingZeroes(key) {
    MenuObject.updateHideTrailingZeroes(this.props.$element, key);
    this.props.setHideTrailingZeroes(key);
  }

  updateInlineExtras(key) {
    MenuObject.updateInlineExtras(this.props.$element, key);
    this.props.setInlineExtras(key);
  }

  updateTagLayout(switchOn) {
    let key = switchOn ? 'below' : 'above';
    MenuObject.updateMenuTagLayout(this.props.$element, key);
    this.props.setMenuTagLayout(key);
  }

  update(type, key, value) {
    const menuObjects = this.props.$elements.filter(it => it.attr('data-component') === 'menu-object');
    MenuObject.patchStyles(this.props.isMultiSelect ? menuObjects : this.props.$element, { type, key, value });
  }

  componentDidMount() {
    if (this.props.$element !== null && Object.keys(this.props.menuObjectStyles).length !== 0 && MenuObject.isMenuObject(this.props.$element)) {
      this.update("", "", "");
    }
  }

  render(props, state) {
    if (props.$element === null || Object.keys(props.menuObjectStyles).length === 0 || !MenuObject.isMenuObject(this.props.$element)) {
      return (
        <div className="menu-object-content mo-deselect-container">
          <h2 className="mo-deselect-title">Select menu text on your design</h2>
          <svg>
            <use xlinkHref={constants.appPrefix + "/svg/icons.svg#mo-with-prices-tab-icon"}/>
          </svg>
        </div>
      );
    }

    const numPrices = MenuObject.getNumPrices(props.menuObjectItems);

    const applyToAllDropdown = (label, applyMode) => {
      return <div className="dropdown apply-to-all-dd">
        <div className={'to-all dropdown-toggle'}>
          Apply to... <DownOutlined/>
        </div>
        <div className="dropdown-menu">
          <ul>
            <li onClick={() => this.applyToAll(label, applyMode)}>All</li>
            <li onClick={(ev) => this.startApplyToMoMode(ev, applyMode)}>Selected</li>
          </ul>
        </div>
      </div>
    }

    return (
      <div className="aside-mo-styles scroller">
        <div className="section-header">
          <span>Groups</span>
          {applyToAllDropdown('group name and notes styles', MenuObject.applyModes.nameNotesStyle)}
        </div>

        <div className="name-note-block">
          <MenuObjectNameNoteStyles
            type='mo-name'
            label='Names'
            onStyleChange={this.onMONameStyleChange.bind(this)}
            openColorPicker={this.openColorPickerMOName}
            nameNoteStyles={props.nameNoteStyles}
            applyToAllDD={applyToAllDropdown('group name styles', MenuObject.applyModes.nameStyle)}
           />
          
        </div>

        <div className="name-note-block">
          <MenuObjectNameNoteStyles
            type='mo-notes'
            label='Notes'
            onStyleChange={this.onMONoteStyleChange.bind(this)}
            openColorPicker={this.openColorPickerMONotes}
            nameNoteStyles={props.nameNoteStyles} 
            applyToAllDD={applyToAllDropdown('note styles', MenuObject.applyModes.notesStyle)}
          />
        </div>

        <div className="section-header" style={"margin-top: 45px;"}>
          <span>Items</span>
          {applyToAllDropdown('item styles', MenuObject.applyModes.itemStyle)}
        </div>

        <MenuObjectStyles
          type='name'
          label='Names'
          onStyleChange={this.onItemNameStyleChange.bind(this)}
          openColorPicker={this.openColorPickerName} 
          applyToAllDD={applyToAllDropdown('item name styles', MenuObject.applyModes.itemNameStyle)}
        />

        <MenuObjectStyles 
          type='description' 
          label='Descriptions' 
          onStyleChange={this.onDescriptionStyleChange.bind(this)}
          openColorPicker={this.openColorPickerDescription}
          applyToAllDD={applyToAllDropdown('item description styles', MenuObject.applyModes.itemDescriptionStyle)}
        />

        <div className={'mos'}>
          <div className="styles-label show-prices-switch" style="margin-bottom: -15px;">
            <div style="display: flex; align-items: center;">
              <h5 style="margin-right: 10px;">Prices</h5>
              <Switch checked={!props.hidePrices} onChange={this.updateHidePrices.bind(this)} size="small" />
            </div>
            {applyToAllDropdown('item price styles', MenuObject.applyModes.itemPriceStyle)}
          </div>
        </div>
        {[...Array(numPrices).keys()].map(num => {
          return <MenuObjectStyles
            type={`price-entry:nth-child(${num+1})`}
            priceNum={num+1}
            label={numPrices > 1 ? `Price ${num+1}` : 'Only Price'}
            onStyleChange={this.onSinglePriceStyleChange.bind(this)}
            openColorPicker={() => this.openColorPickerSinglePrice(num+1)}
          />
        })}

        <div className="mos price-options">
          <div className="show-prices-switch">
            <h5>Hide Zeroes<s>.00</s></h5>
            <Switch checked={props.hideTrailingZeroes} onChange={this.updateHideTrailingZeroes.bind(this)} size="small" />
          </div>

          <MenuObjectPriceDividers/>
        </div>

        <MenuObjectStyles 
          type='extras' 
          label='Extras' 
          onStyleChange={this.onExtrasStyleChange.bind(this)}
          openColorPicker={this.openColorPickerExtras}
          applyToAllDD={applyToAllDropdown('item extras styles', MenuObject.applyModes.itemExtrasStyle)}
        />
        
        <div className="show-prices-switch mos">
          <h5>In-line Extras</h5>
          <Switch checked={props.inlineExtras} onChange={this.updateInlineExtras.bind(this)} size="small" />
        </div>

        {props.menuObjectLayout.indexOf('bin') > -1 && 
        <MenuObjectStyles 
          type='bin' 
          label='BIN' 
          onStyleChange={this.onBinStyleChange.bind(this)}
          openColorPicker={this.openColorPickerBin} 
        />}

        <IconStyles
          type='icon-entry' 
          label='Icons' 
          onStyleChange={this.onIconStyleChange.bind(this)}
          onAllStyleChange={this.onAllIconStyleChange.bind(this)}
          openColorPicker={this.openColorPickerIcon} 
          applyToAllDD={applyToAllDropdown('item icon styles', MenuObject.applyModes.itemIconsStyle)}
        />

        <div className="section-header" style={"margin-top: 45px;"}>
          <span>
            Modifiers
            <Switch checked={props.showModifiers} onChange={this.updateShowModifiers.bind(this)} size="small" />
          </span>
          {applyToAllDropdown('item modifier styles', MenuObject.applyModes.modifiersStyle)}
        </div>

        <div className={!props.showModifiers ? 'tag-setting-disabled' : ''}>
          <MenuObjectStyles 
            type='modifier-name'
            label="Group Names"
            onStyleChange={this.onModifierNameStyleChange.bind(this)}
            openColorPicker={this.openColorPickerModifierName}
            applyToAllDD={applyToAllDropdown('item modifier group name styles', MenuObject.applyModes.modifiersNameStyle)} 
          />

          <MenuObjectStyles 
            type='modifier-entry-name'
            label="Modifier Names"
            onStyleChange={this.onModifierEntryNameStyleChange.bind(this)}
            openColorPicker={this.openColorPickerModifierEntryName} 
            applyToAllDD={applyToAllDropdown('item modifier name styles', MenuObject.applyModes.modifiersEntryNameStyle)}
          />

          <MenuObjectStyles 
            type='modifier-entry-price'
            label="Prices"
            onStyleChange={this.onModifierEntryPriceStyleChange.bind(this)}
            openColorPicker={this.openColorPickerModifierEntryPrice} 
            applyToAllDD={applyToAllDropdown('item modifier price styles', MenuObject.applyModes.modifiersEntryPriceStyle)}
          />
        </div>

        <div className="menu-tag-toggles">
          <div className={`tag-layout ${!props.showModifiers ? 'tag-setting-disabled' : ''}`}>
            <span>In-line</span>
            <Switch checked={props.modifierLayout === 'stacked'} onChange={this.updateModifierLayout.bind(this)} size="small" />
            <span>Stacked</span>
          </div>
        </div>

        {props.modifierLayout !== 'stacked' && <div className={`mos ${!props.showModifiers ? 'tag-setting-disabled' : ''}`}>
          <MenuObjectModifierDividers/>
        </div>}
        
        <div className="section-header" style={"margin-top: 45px;"}>
          <span>
            Menu Tags
            <Switch checked={props.showMenuTag} onChange={this.updateShowMenuTag.bind(this)} size="small" />
          </span>
          {applyToAllDropdown('item tag styles', MenuObject.applyModes.tagStyle)}
        </div>

        <div className="menu-tag-toggles">
          <div className={`tag-layout ${!props.showMenuTag ? 'tag-setting-disabled' : ''}`}>
            <span>Above Description</span>
            <Switch checked={props.menuTagLayout === 'below'} onChange={this.updateTagLayout.bind(this)} size="small" />
            <span>Below Description</span>
          </div>
        </div>

        <div className={!props.showMenuTag ? 'tag-setting-disabled' : ''}>
          <MenuObjectStyles 
          type='tag'
          label="Tag"
          onStyleChange={this.onTagStyleChange.bind(this)}
          openColorPicker={this.openColorPickerTag} />
        </div>
      </div>
    )
  }
}
